import { getDatasetInfo, mergeDatasetInfoExtras } from '../offline-features/getDatasetInfo.js';
import { setDatasetInfo, setDatasets } from '../context/datasets.js';
import { openDataset, closeDataset } from '../context/openDatasets.js';

export const sourceFormatLabel = dataset => (
	dataset?.SourceFormat === 'mspdi' ? 'MSP' : 'P6'
);

export const dispatchDatasetInfo = (dispatch, datasetId, result, datasets) => {
	const id = String(datasetId);
	dispatch(setDatasetInfo(
		id,
		result.wbsTree,
		result.activities,
		result.activitiesMap,
		result.activityCodesRelativesMap,
		Array.isArray(result.activityCodesTree) ? null : result.activityCodesTree,
		result.activityCodesTreeSequence,
		result.layouts,
		result.Id || null,
		result.ViewType || 'WBS List',
		result.GroupBy || null,
		result.GroupByActivityCode || null,
		result.MapGroupBy || null
	));
	if (datasets?.[id]) {
		dispatch(setDatasets({
			...datasets,
			[id]: mergeDatasetInfoExtras(datasets[id], result)
		}));
	}
};

export const openInSession = ({ dispatch, datasetId }) => {
	dispatch(openDataset(String(datasetId)));
};

export const focusProject = ({ dispatch, navigate, datasetId, datasets }) => {
	const id = String(datasetId);
	dispatch(openDataset(id));
	if (typeof navigate === 'function') {
		navigate(`/app/dataset/${id}`);
	}
	return getDatasetInfo(dispatch, id).then(result => {
		if (result.success) {
			dispatchDatasetInfo(dispatch, id, result, datasets);
		}
		return result;
	});
};

export const closeOpenProject = ({
	dispatch,
	navigate,
	datasetId,
	openDatasets,
	focusedDatasetId,
	datasets,
	redirectIfFocused = true
}) => {
	const id = String(datasetId);
	const remaining = (openDatasets || []).filter(openId => String(openId) !== id);
	dispatch(closeDataset(id));
	if (String(focusedDatasetId) !== id) {
		return remaining;
	}
	if (remaining.length && redirectIfFocused) {
		focusProject({
			dispatch,
			navigate,
			datasetId: remaining[0],
			datasets
		});
		return remaining;
	}
	dispatch(setDatasetInfo(null));
	if (redirectIfFocused && typeof navigate === 'function') {
		navigate('/app/');
	}
	return remaining;
};
